export default {
  project: {
    id: '',
    code: '',
    nameLocal: '',
    nameEng: '',
  },
  projects: [],
  processing: false,
  error: null,
  success: null,
}



